import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    rtoAll: [],
    rto: {},
    currentPage: 1,
    totalPages: 1,
    rowsPerPage: 10,
    sortBy: "name",
    sortOrder: "asc",
};

const rtoSlice = createSlice({
    name: "rto",
    initialState,
    reducers: {
        setRtoAll: (state, action) => {
            state.rtoAll = action.payload;
        },
        setRto: (state, action) => {
            state.rto = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        },
    },
});

export const {
    setRtoAll,
    setRto,
    setCurrentPage,
    setTotalPages,
    setRowsPerPage,
} = rtoSlice.actions;

export default rtoSlice.reducer;
